import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import MainRoutes from "./Route/MainRoutes";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Provider } from "react-redux";
import store from "./redux/Store";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  // useEffect(() => {
  //   const handleContextMenu = (e) => {
  //     e.preventDefault();
  //   };

  //   const handleKeyDown = (e) => {
  //     // F12
  //     if (e.key === "F12") {
  //       e.preventDefault();
  //     }

  //     // Ctrl + Shift + I / J / C
  //     if (
  //       e.ctrlKey &&
  //       e.shiftKey &&
  //       ["I", "J", "C"].includes(e.key.toUpperCase())
  //     ) {
  //       e.preventDefault();
  //     }

  //     // Ctrl + U
  //     if (e.ctrlKey && e.key.toUpperCase() === "U") {
  //       e.preventDefault();
  //     }
  //   };

  //   document.addEventListener("contextmenu", handleContextMenu);
  //   document.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <MainRoutes />

        <ToastContainer
          position="top-right"
          autoClose={2000}
          theme="dark"
        />
      </BrowserRouter>
    </Provider>
  );
}

export default App;